function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-53.8,422.6c2.4-6.4,3.2-12,3.2-19.2c0-8-1.6-15.2-4.8-22.4c-2.4-7.2-6.4-13.6-12-19.2c-4.8-5.6-11.2-10.4-18.4-13.6 c-7.2-3.2-14.4-5.6-22.4-5.6L-109,317h-6.4l-0.8,25.6c-8,0-15.2,2.4-22.4,5.6c-7.2,4-13.6,8-18.4,13.6s-9.6,12-12,19.2 c-3.2,6.4-4.8,14.4-4.8,22.4s1.6,15.2,4,22.4c3.2,6.4,7.2,12.8,12,18.4c5.6,5.6,11.2,10.4,17.6,13.6c7.2,3.2,13.6,5.6,21.6,6.4V477 l12.8-4v-8.8c4.8,0,8.8-1.6,12.8-2.4s8-2.4,11.2-4.8l8,5.6l-5.6-7.2c5.6-3.2,10.4-8,14.4-12.8s7.2-10.4,9.6-16.8l11.2-0.8 L-53.8,422.6z M-157.8,403.4l32.8,22.4l-14.4,20.8l20.8-10.4l0.8,3.2v20.8c-6.4-0.8-12.8-2.4-18.4-5.6c-6.4-3.2-11.2-7.2-15.2-12 c-4.8-4.8-8-10.4-10.4-16.8s-4-12.8-4-20s1.6-13.6,4-20s5.6-12,10.4-16.8c4-5.6,9.6-9.6,15.2-12c5.6-3.2,12-4.8,19.2-5.6l-2.4,61.6 L-157.8,403.4z M-78.6,386.6l-28,20.8l-2.4-56.8c7.2,0.8,14.4,2.4,20,5.6c6.4,3.2,11.2,7.2,16,12c4,4.8,8,10.4,10.4,16.8 s4,12.8,4,20c0,6.4-0.8,12-3.2,17.6l-36.8-6.4L-78.6,386.6z M-63.4,426.6c-2.4,4.8-4.8,9.6-8.8,13.6c-3.2,4-7.2,7.2-12,10.4 l-15.2-20.8L-63.4,426.6z M-87.4,452.2c-3.2,2.4-5.6,3.2-8.8,4c-2.4,1.6-5.6,1.6-9.6,2.4v-20L-87.4,452.2z"
});

var SvgSwrpgTriumph = function SvgSwrpgTriumph(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgTriumph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-triumph.32194892.svg";
export { ForwardRef as ReactComponent };